import log from 'sentry/log'

const replaceSpacesInAmount = (string) => {
  try {
    // prevent amount like '5 000 kr' to split on linebreak
    const regex = /(\d[0-9 ]*) kr/
    const found = string.match(regex)
    if (found) {
      const nobr = found[0].replaceAll(' ', '\u00A0') /* unicode for no break space */
      string = string.replaceAll(found[0], nobr)
    }
  } catch (e) {
    log.message(`replaceSpacesInAmount failure: ${e}`)
  }

  return string
}

export default replaceSpacesInAmount
